import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LogLevel, levelEnabled } from './log-level';

export interface LogContext { [k: string]: unknown }
export interface LogEntry {
  level: LogLevel;
  message: string;
  timestamp: string;
  context?: LogContext;
  app?: string;
}

@Injectable({ providedIn: 'root' })
export class Logger {
  private currentLevel: LogLevel = environment.logLevel as LogLevel;

  constructor(private http: HttpClient) {}

  setLevel(level: LogLevel) { this.currentLevel = level; }

  trace(msg: string, ctx?: LogContext) { this.log('trace', msg, ctx); }
  debug(msg: string, ctx?: LogContext) { this.log('debug', msg, ctx); }
  info (msg: string, ctx?: LogContext) { this.log('info',  msg, ctx); }
  warn (msg: string, ctx?: LogContext) { this.log('warn',  msg, ctx); }
  error(msg: string, ctx?: LogContext) { this.log('error', msg, ctx); }

  private log(level: LogLevel, message: any, context?: LogContext) {
    if (!levelEnabled(this.currentLevel, level)) return;

    const entry: LogEntry = {
      level,
      message,
      context,
      app: environment.appName,
      timestamp: new Date().toISOString(),
    };

    // Consola (silenciada parcialmente en prod)
    switch (level) {
      case 'trace': console.trace?.(message, context ?? ''); break;
      case 'debug': console.debug?.(message, context ?? ''); break;
      case 'info':  console.info?.(message, context ?? '');  break;
      case 'warn':  console.warn?.(message, context ?? '');  break;
      case 'error': console.error?.(message, context ?? ''); break;
    }

    // Envío opcional a backend
    if (environment.remoteLogUrl && level !== 'trace') {
      // Evita bloquear la UI: fire-and-forget
      this.http.post(environment.remoteLogUrl, entry).subscribe({ next: () => {}, error: () => {} });
    }
  }
}
